/* Cartes produit Whoosh : portage des parties « use client » de
   src/template/produits/CarteProduit.tsx et VisuelAssechement.tsx.

   Le reste des effets de la carte est en CSS dans les feuilles compilées de la
   maquette (wh-0xfnmda7da7bo.css) et marche tel quel :
   - survol : la photo au repos s'efface en 0,3 s et découvre la photo du
     dessous (souris uniquement) ;
   - bouton panier : les deux icônes glissent vers le haut au survol ;
   - carrousel de l'accueil (.ap-cartes--carrousel) : défilement horizontal
     avec arrêt sur chaque carte, sous 1024 px.

   Ce fichier peut être chargé plusieurs fois sur une page (une fois par
   section) : il ne s'installe qu'une fois. */
(function () {
  if (window.__whProduits) return;
  window.__whProduits = true;

  /* --- Bouton panier ------------------------------------------------------
     La maquette envoie « tpl-panier:ajouter » au clic. Ici la carte porte l'id
     de la variante (data-variante) et on passe par Whoosh.ajouter, qui émet le
     même événement au format Shopify ({ items: [{ id, quantity }] }).
     Écouteur posé sur le document : il sert aussi aux cartes que l'éditeur de
     thème redessine, sans rien réinitialiser. */
  document.addEventListener("click", function (e) {
    var cible = e.target;
    var bouton = cible && cible.closest ? cible.closest(".ap-carte__bouton[data-variante]") : null;
    if (!bouton) return;
    var id = Number(bouton.getAttribute("data-variante"));
    if (!id) return;
    var items = [{ id: id, quantity: 1 }];
    if (window.Whoosh && typeof window.Whoosh.ajouter === "function") {
      window.Whoosh.ajouter(items);
    } else {
      window.dispatchEvent(new CustomEvent("tpl-panier:ajouter", { detail: { items: items } }));
    }
  });

  /* --- Démonstration du visuel sur écran tactile ---------------------------
     VisuelAssechement : sans survol possible, la carte jouait une fois la
     transition (classe assec--demo) en entrant à 60 % dans l'écran. Coupée
     dans la maquette (SANS_DEMO = true, demande Raph 12/10 : la couette pliée
     reste affichée sur mobile). Même interrupteur ici. */
  var SANS_DEMO = true;
  var observateurs = [];

  function initialiser(racine) {
    if (SANS_DEMO || !("IntersectionObserver" in window)) return;
    var visuels = racine.querySelectorAll(".assec");
    Array.prototype.forEach.call(visuels, function (el) {
      if (el.__whDemo) return;
      el.__whDemo = true;
      /* Relu à l'entrée dans l'écran, pas au chargement : un appareil peut
         passer du pointeur au tactile entre les deux. */
      var tactile = function () { return !window.matchMedia("(hover: hover)").matches; };
      var calme = function () { return window.matchMedia("(prefers-reduced-motion: reduce)").matches; };
      var oeil = new IntersectionObserver(function (entrees) {
        entrees.forEach(function (entree) {
          if (!entree.isIntersecting) return;
          if (!tactile() || calme()) return;
          el.classList.add("assec--demo");
          oeil.disconnect();
        });
      }, { threshold: 0.6 });
      oeil.observe(el);
      observateurs.push({ el: el, oeil: oeil });
    });
  }

  function nettoyer(racine) {
    observateurs = observateurs.filter(function (o) {
      if (!racine.contains(o.el)) return true;
      o.oeil.disconnect();
      o.el.__whDemo = false;
      return false;
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () { initialiser(document); });
  } else {
    initialiser(document);
  }

  /* Éditeur de thème : une section redessinée repart de zéro. */
  document.addEventListener("shopify:section:load", function (e) { initialiser(e.target); });
  document.addEventListener("shopify:section:unload", function (e) { nettoyer(e.target); });
})();
